module.exports = __webpack_public_path__ + "static/media/ballAppearFast.ea9745a4.mp3";